import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ICCNDisciplineInputModel, ICCNApproverInputModel, ICCNByIdModel, ICCNUpdateInputModel, ICCNApproveInputModel, ICCNManhoursInputModel } from 'src/app/ViewModel/CCNModel';
import { CcnService } from 'src/app/Service/ccn/ccn.service';
import { CommonService } from 'src/app/Service/Common.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { StandardOutputModel } from 'src/app/ViewModel/StandardOutputModel';
import { ChangeControlCreateComponent } from '../../change-control-create/change-control-create.component';
import { CcnPrintComponent } from '../../change-control-create/ccn-print-dialog/ccn-print/ccn-print.component';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from "rxjs";
import { Module } from 'src/app/Service/element-details.data.service';
@Component({
  selector: 'app-ccn-view',
  templateUrl: './ccn-view.component.html',
  styleUrls: ['./ccn-view.component.css']
})
export class CcnViewComponent implements OnInit, OnDestroy {
  private _viewData!: any[];
  get viewData(): any {
    return this._viewData;
  }
  @Input() set viewData(value: any) {
    if (!!value && typeof value == "object") {
      this._viewData = value;
      this.loadInitialData();
    }
  }
  projectId!: number;
  memberId!: number ;
  groupId!: number ;
  public ccn: any;
  public MHList: any[] = [];
  project: string = '';
  initiatedBy: string = '';
  discCode: number = 0;
  discipline: string = '';
  approvers: string = '';
  canEdit: boolean = false;
  canApprove: boolean = false;
  canPublish: boolean = false;
  canPrint: boolean = false;
  UnsubscribeArray:Subscription[]=[];
  public enableFullscreen:boolean=false;
  constructor(
    private commonService: CommonService,
    private notificationService: NotificationService,
    private ccnService: CcnService,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.memberId = this.commonService.getLoggedInUserId();
    this.projectId = this.commonService.getProjectId();
    this.groupId = this.commonService.getLoggedInUserGroupId();
  }

  async loadInitialData() {
    var project = JSON.parse(this.commonService.getSessionStorageItem('projectObject'));
    this.project = this.commonService.getProjectCode() + ' - ' + project.projectDescription;
    this.initiatedBy = this.commonService.getLoggedInUserName();
    let ccnInput: ICCNByIdModel = {
      cCNId: this.viewData[0].ccnId,
      cCNRevNo: this.viewData[0].revisionNo
    }
    this.getCCN(ccnInput);
    this.getCCNDetails(ccnInput as ICCNManhoursInputModel);
  }

  async getDiscipline() {
    let ccnInput: ICCNDisciplineInputModel = { projectId: this.projectId, memberId: this.ccn.createdBy, groupId: this.groupId, module: Module.ScheduleDocument  };
    let res = await this.ccnService.GetDisciplineDetails(ccnInput).toPromise();
    if (res.length > 0) {
      this.discCode = res[0]['dedId'];
      this.discipline = res[0]['dedDescription'];
      this.getApprovers();
    }
    else {
      this.notificationService.showToast("Logged In User is not mapped to any discipline.", "Warning");
    }
  }

  async getApprovers() {
    let ccnInput: ICCNApproverInputModel = { projectId: this.projectId, discCode: this.discCode, groupId: this.groupId, module: Module.ScheduleDocument };
    let res = await this.ccnService.GetApproverDetails(ccnInput).toPromise();
    res.forEach((element: { [x: string]: string; }) => {
      if (!this.approvers.includes(element['memberName'])) {
        if (this.approvers != '') {
          this.approvers += ', ';
        }
        this.approvers += element['memberName'];
      }
    });
  }

  async getCCN(ccnInput: ICCNByIdModel) {
    let res = await this.ccnService.GetCCNById(ccnInput).toPromise();
    if (res != null && res.length > 0) {
      this.ccn = res[0];
      this.canPrint = this.ccn.submitDate != null;
      this.canEdit = this.ccn.publishDate == null;
      this.canApprove = this.ccn.approvedDate == null && this.ccn.submitDate != null;
      this.canPublish = this.ccn.approvedDate != null && this.ccn.submitDate != null && this.ccn.publishDate == null;
      this.getDiscipline();
    }
    else {
      this.notificationService.showToast("Invalid Data", "Warning");
    }
  }

  async getCCNDetails(ccnInput: ICCNManhoursInputModel) {
    this.MHList = await this.ccnService.GetCCNDetails(ccnInput).toPromise();
  }

  async approveCCN(isApproved: boolean) {
    let inputModel: ICCNApproveInputModel = {
      cCNId: this.viewData[0].ccnId,
      cCNRevNo: this.viewData[0].revisionNo,
      userId: this.memberId,
      isApproved: isApproved
    };
    let ccnapprove = await this.ccnService.ApproveCCN(inputModel).subscribe((res: StandardOutputModel) => {
      if (res.successCode == 200) {
        this.notificationService.showToast(res.successMessage, "Success");
      }
      else {
        this.notificationService.showToast(res.successMessage, "Warning");
      }
      this.loadInitialData();
    });
    this.UnsubscribeArray.push(ccnapprove);
  }

  async publishCCN() {
    let ccnInput: ICCNUpdateInputModel = {
      cCNId: this.viewData[0].ccnId,
      cCNRevNo: this.viewData[0].revisionNo,
      userId: this.memberId
    }
    let ccnpublish = this.ccnService.PublishCCN(ccnInput).subscribe((res: StandardOutputModel) => {
      if (res.successCode == 200) {
        this.notificationService.showToast(res.successMessage, "Success");
      }
      else {
        this.notificationService.showToast(res.successMessage, "Warning");
      }
      this.loadInitialData();
    });
    this.UnsubscribeArray.push(ccnpublish);
  }

  printCCN() {
    let dialogRef = this.dialog.open(CcnPrintComponent, {
      panelClass: ['mat-dialog-primary'],
      data: { ccnId: this.viewData[0].ccnId, ccnRevNo: this.viewData[0].revisionNo, discCode: this.discCode }
    });
  }

  editCCN() {
    let dialogRef = this.dialog.open(ChangeControlCreateComponent, {
      panelClass: ['mat-dialog-primary'],
      data: { ccnId: this.viewData[0].ccnId, ccnRevNo: this.viewData[0].revisionNo }
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      this.loadInitialData();
    });
  }

  ngOnDestroy():void
  {
  this.UnsubscribeArray.forEach(x=>x.unsubscribe());
  }

}
